/**
 * The labels (tunnisteet) of a Kuutio instance as small chips (#1209):
 * `tags` from kuutio_instances, vocabulary in packages/shared/instanceLabels.js.
 * Read-only; LabelPicker edits them.
 */
import React from 'react';
import styled from '@emotion/styled';
import { useTranslation } from '../../hooks/useTranslation.jsx';

export const LABEL_COLORS = {
  kuutio: '#4ade80',
  demo: '#fbbf24',
  simulation: '#c084fc',
  test: '#9ca3af',
  lab: '#38bdf8',
  event: '#f472b6',
};

const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 1px 8px;
  border-radius: 999px;
  border: 1px solid ${p => p.$color};
  color: ${p => p.$color};
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 16px;
  white-space: nowrap;
`;

const Row = styled.span`
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export function LabelChip({ label }) {
  const { t } = useTranslation();
  return <Chip $color={LABEL_COLORS[label] || '#9ca3af'}>{t(`instanceLabels.${label}`)}</Chip>;
}

export default function LabelChips({ tags, emptyText }) {
  const list = Array.isArray(tags) ? tags : [];
  if (list.length === 0) return emptyText ? <Chip $color="#f87171">{emptyText}</Chip> : null;
  return <Row>{list.map((label) => <LabelChip key={label} label={label} />)}</Row>;
}
